import { Checkbox, Tooltip } from '@mui/material';
import { useResponse } from '../utils/itemDataProvider';
import DriveFileRenameOutlineTwoToneIcon from '@mui/icons-material/DriveFileRenameOutlineTwoTone';
import { useTheme } from '@emotion/react';

function ActionButton({ val, setOpen, setModalData, dataFilled, returnData, setReturnData }) {
    const { response } = useResponse();
    const theme = useTheme();

    const handleClick = () => {
        if (!dataFilled) {
            setModalData(val);
            setOpen(true);
        } else {
            const updatedReturnData = returnData.filter(entry => entry.data.item.sku_id !== val.item.sku_id);
            setReturnData(updatedReturnData);
        }
    };

    const handleEdit = () => {
        setModalData(val);
        setOpen(true);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={dataFilled ? "Click to unselect" : "Click to save return data for this item"}>
                <Checkbox
                    checked={dataFilled}
                    color={dataFilled ? "success" : 'default'}
                    onChange={handleClick}
                    disabled={!val?.isReturnAllowed || response?.isLastDateExpired || response?.isAllOrderReturn || (val?.totalFwdUnits - val?.requestedReturnItems === 0)}
                    sx={{
                        ml:-12,
                        color: (theme) =>
                            !val?.isReturnAllowed || response?.isLastDateExpired || response?.isAllOrderReturn || (val?.totalFwdUnits - val?.requestedReturnItems === 0)
                                ? theme.palette.grey[400]
                                : dataFilled,
                        '&.Mui-disabled': {
                            opacity: 0.5,
                        },
                        '& .MuiSvgIcon-root': { fontSize: 25 }
                    }}
                />
            </Tooltip>
            {dataFilled && (
                <Tooltip title={dataFilled ? "Click to Edit" : ""}>
                    <DriveFileRenameOutlineTwoToneIcon
                        color="primary"
                        onClick={handleEdit}
                        sx={{
                            marginLeft: 1,
                            fontSize: 25,
                            transition: 'transform 0.2s, color 0.2s',
                            '&:hover': {
                              transform: 'scale(1.2)',
                              color: theme.palette.primary.main,
                            },
                            '&:active': {
                              transform: 'scale(0.9)',
                            }
                          }}
                                      />
                </Tooltip>
            )}
        </div>
    );
}

export default ActionButton;
